// import { Formik, Form, Field } from "formik";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
} from "@mui/material";

function Level10Meeting() {
  return (
    <>
      <Accordion>
        <AccordionSummary>
          Review of the prior week's progress on Rocks (goals)
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the prior week's progress on Issues
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the current week's priorities (Rocks)
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the current week's meeting rhythms (daily huddles, team
          meetings, etc.)
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the current week's Key Performance Indicators (KPIs)
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of any current or potential constraints or bottlenecks
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>Review of the current week's wins</AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the current week's lessons learned
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Review of the current week's to-do list for each team member
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary>
          Selection of the next quarter's Rocks
        </AccordionSummary>
        <AccordionDetails>
          <List />
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export default Level10Meeting;
